export default __webpack_public_path__ + "static/media/ethereum_logo_squared.ac320585.svg";